import { configureStore } from "@reduxjs/toolkit";
import user from "./modules/user";
import helper from "./modules/helper";
export default configureStore({
  reducer: {
    user,
    helper,
  },
});